import { FormConfig } from '@topdanmark-onlinesolutions/claim-form-types';

export const getPageIdFirst = (formConfig: FormConfig): string => {
    const { formId } = formConfig;

    const firstPageId = `/${formId}/${formConfig.pages[0].pageId}`;

    return firstPageId;
};
